import { FilePickerField, FormFieldset, FormGrid, InputField } from '@app/components/various/Form';
import { Settings } from '@typings';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
  isDisabled: boolean;
  isLoading: boolean;
}

export const BrandElementsFields = ({ isDisabled, isLoading }: Props) => {
  const { t } = useTranslation(['common', 'settings', 'linesheets']);
  const { register } = useFormContext<Settings.CustomisationFormFields>();

  return (
    <section className="box space-y-5">
      <h3 className="heading-3">{t('settings:brand_elements')}</h3>
      <p className="text-neutral-40 body-2">{t('settings:brand_elements_subtitle')}</p>
      <FormFieldset isDisabled={isDisabled}>
        <FormGrid rowGap="medium">
          <InputField
            label={t('common:company_name')}
            helpMessage={t('settings:company_name_description')}
            placeholder={t('common:company_name')}
            isLoading={isLoading}
            {...register('companyName')}
          />
          <FilePickerField
            label={t('settings:company_logo')}
            helpMessage={t('settings:company_logo_hint')}
            name="logoImage"
            isDisabled={isDisabled}
            isLoading={isLoading}
            fitPreview
          />
          <FilePickerField
            label={t('settings:background_media')}
            helpMessage={t('settings:background_media_hint')}
            name="backgroundImage"
            isDisabled={isDisabled}
            isLoading={isLoading}
          />
        </FormGrid>
      </FormFieldset>
    </section>
  );
};
